import { set as setCookie } from "../../../exports/cookie";
import type { BreakpointUnknown, Breakpoint } from "../breakpoint/types";

/**
 *
 *
 *
 */
export const setDevSpecsCookie = (bp: Breakpoint | BreakpointUnknown | undefined): void => {
  /*                                       */
  if (!bp) return;

  const { clientHeight, clientWidth } = document.documentElement;
  const cookieValue = `w=${clientWidth}&h=${clientHeight}&bp=${bp}`;
  setCookie("devSpecs", cookieValue, { days: 365, encode: false, domain: ".otto.de" });
};
